import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Link, LinkProps } from '@mui/material';

export type ExternalLinkProps = Omit<LinkProps, 'target'>;

/**
 * Link to a page outside of the backoffice: opens in a new tab and shows an icon next to the text.
 * Use it for every link that leaves the BO, `Link` from react-router is for BO pages.
 */
export const ExternalLink = ({ children, sx, rel, ...props }: ExternalLinkProps) => (
  <Link
    target="_blank"
    rel={rel ?? 'noopener noreferrer'}
    {...props}
    sx={[
      { display: 'inline-flex', alignItems: 'center', gap: 0.5 },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}>
    {children}
    <OpenInNewIcon fontSize="inherit" aria-hidden />
  </Link>
);
